import App from 'components/App/App';
import React, { Suspense } from 'react';
import TeamsRoutes from 'routes/teams';
import { createRoot } from 'react-dom/client';
import '@matterapp/matter-fonts/build/fonts.css';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { Resources } from '@matterapp/routing';
import Loader from 'components/Loader/Loader';

Resources.config({
  WebClient: ENV_VARS.WEB_CLIENT_HOST
});

function ClientRouter() {
  return (
    <>
      <CssBaseline />
      <GlobalStyles styles={{
        body: {
          letterSpacing: 0,
        },
      }} />
      <App>
        <Suspense fallback={<Loader />}>
          <TeamsRoutes />
        </Suspense>
      </App>
    </>
  );
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<ClientRouter />);